<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>UCC Filing</mat-card-title>
  </mat-card-header>

  <mat-card-content class="card-content">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="resubmitUCC1FilingTemplate">
        <div class="action-item">
          <a class="action-item__text" (click)="onClickResubmitUCC1Filing()"
            >Resubmit UCC Filing</a
          >
          <button
            mat-icon-button
            matTooltip="Resubmit UCC Filing"
            class="action-button"
            (click)="onClickResubmitUCC1Filing()"
          >
            <mat-icon class="action-button__icon">send</mat-icon>
          </button>
        </div>
      </ng-template>
      <ng-template horizontalListCustomTemplate="refreshUCC1Template">
        <div class="action-item">
          <a class="action-item__text" (click)="onClickRefreshUCC1()"
            >Refresh</a
          >
          <button
            mat-icon-button
            matTooltip="Refresh"
            class="action-button"
            (click)="onClickRefreshUCC1()"
          >
            <mat-icon class="action-button__icon">refresh</mat-icon>
          </button>
        </div>
      </ng-template>
      <ng-template horizontalListCustomTemplate="downloadUCC1Document">
        <div class="action-item">
          <a class="action-item__text" (click)="onClickDownloadUCC1Document()"
            >{{ uccFiling?.document?.filename }}</a
          >
          <ifc-status-label
            *ngIf="isProvisionalDocument"
            class="provisional-document-label"
            [status]="UCCFilingDocumentLabels"
            [value]="PROVISIONAL_UCC_FILING_DOCUMENT"
          ></ifc-status-label>
        </div>
      </ng-template>
      <ng-template horizontalListCustomTemplate="uccFilingStatusValueTemplate">
        <div class="status-container">
          <ifc-status-label
            [status]="UCCFilingStatusLabels"
            [value]="uccFiling?.status"
          ></ifc-status-label>
        </div>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
